import React from 'react';
import { Button } from './ui/button';
import './Header.css';

const Header = ({ isSticky }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className={`lodge-header ${isSticky ? 'sticky' : ''}`}>
      <div className="header-container">
        <div className="header-brand">
          <span className="brand-text">THE LODGE</span>
        </div>
        
        <nav className="header-nav">
          <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
          <button onClick={() => scrollToSection('studio')} className="nav-link">Studio</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
          <Button 
            variant="outline" 
            className="book-button"
            onClick={() => window.open('https://www.fresha.com/book-now/the-lodge-inside-salon-rose-d5hpq959/all-offer?share=true&pId=1274239', '_blank')}
          >
            BOOK
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;